import ModalController from './modal_controller'
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import Modal from '../../../frontend/components/Modal.vue'
import MorePopover from '../../../frontend/components/MorePopover.vue'
import CalendarPopover from '../../../frontend/components/CalendarPopover.vue'
import PrimeVue from 'primevue/config'

export default class extends ModalController {
  static values = {
    url: String,
    data: Object
  }

  connect() {
    console.log('automodal engaged: ', this.urlValue)

    this.modalApp = createApp(Modal)
    this.modalApp.use(PrimeVue, { unstyled: true })
    this.modalApp.component('morepopover', MorePopover)
    this.modalApp.component('calendarpopover', CalendarPopover)

    const app = this.modalApp.mount('#auto-modal-box')

    this.open_url = app.open_url

    if (this.urlValue) {
      console.log('automodal opening URL')
      this.open_url(this.urlValue, this.dataValue || {})
    }
  }
}
